import { useEffect, useState } from "react";

import { 
    Button,
    Card,
    CardBody,
    CardTitle,
    Form,
    FormGroup,
    Input,
    Label
} from "reactstrap";

import GroupCreationRequestService
from "../Services/GroupCreationRequestService";

interface Props {

    keyword: string;

}

const CreateGroupRequestPage = ({
    keyword
}: Props) => {

    const [courseName,
        setCourseName] =
        useState("");

    const [category,
        setCategory] =
        useState("");

    const [description,
        setDescription] =
        useState("");

    const [success,
        setSuccess] =
        useState(false);

    const [loading,
        setLoading] =
        useState(false);

    useEffect(() => {

        setCourseName(keyword);

    }, [keyword]);

    const submit = async (
        e: React.FormEvent
    ) => {

        e.preventDefault();

        setLoading(true);

        try {

            await GroupCreationRequestService.create({

                courseName,

                category,

                description

            });

            setSuccess(true);

            setCategory("");

            setDescription("");

        }
        finally {

            setLoading(false);

        }

    };

    if (success)

        return (

            <Card
                className="mt-4 mx-auto"
                style={{
                    maxWidth: 700
                }}
            >

                <CardBody
                    className="text-center"
                >

                    <h4>

                        🎉 Request Submitted

                    </h4>

                    <p>

                        We'll notify you once
                        enough learners join
                        this course request.

                    </p>

                </CardBody>

            </Card>

        );

    return (

        <Card
            className="mt-4 mx-auto"
            style={{
                maxWidth: 700
            }}
        >

            <CardBody>

                <CardTitle tag="h4">

                    Couldn't find your course?

                </CardTitle>

                <p className="text-muted">

                    Request this course and we'll
                    create a learning group when
                    enough people are interested.

                </p>

                <Form onSubmit={submit}>

                    <FormGroup>

                        <Label>

                            Course Name

                        </Label>

                        <Input
                            value={courseName}
                            onChange={(e) =>
                                setCourseName(
                                    e.target.value
                                )
                            }
                            required
                        />

                    </FormGroup>

                    <FormGroup>

                        <Label>

                            Category

                        </Label>

                        <Input
                            value={category}
                            onChange={(e) =>
                                setCategory(
                                    e.target.value
                                )
                            }
                            placeholder="Programming, AI, CAD..."
                            required
                        />

                    </FormGroup>

                    <FormGroup>

                        <Label>

                            Description

                        </Label>

                        <Input
                            type="textarea"
                            rows={4}
                            value={description}
                            onChange={(e) =>
                                setDescription(
                                    e.target.value
                                )
                            }
                        />

                    </FormGroup>

                    <Button
                        color="primary"
                        disabled={loading}
                    >

                        {

                            loading

                                ?

                                "Submitting..."

                                :

                                "Submit Request"

                        }

                    </Button>

                </Form>

            </CardBody>

        </Card>

    );

};

export default CreateGroupRequestPage;